import gql from 'graphql-tag';

export default gql`
  fragment roomCalendarFragment on RoomCalendarType {
    id
    roomId
    eventId
    targetDate
    startTime
    startTimeText
    endTime
    endTimeText
    targetDateText
    calendarType
    memo
  }
`;
